export default __webpack_public_path__ + "static/media/eye.421ef61a.svg";